import {Injector} from '@angular/core';

export class FourDInjector{

  static injector;
  constructor(public injector: Injector){
    FourDInjector.injector = injector;
  }
}
